import { useId, type ReactNode } from 'react';

const gente = (
  <>
    <circle cx="9" cy="8" r="3.5" />
    <path d="M2.5 20v-1.5A4.5 4.5 0 0 1 7 14h4a4.5 4.5 0 0 1 4.5 4.5V20" />
    <circle cx="17" cy="9" r="2.6" />
    <path d="M17.5 14H18a3.5 3.5 0 0 1 3.5 3.5V20" />
  </>
);

const PATHS: Readonly<Record<string, ReactNode>> = {
  /* Indicar amigos (techspec-indicacoes §04): uma pessoa e o "+". */
  indicar: (
    <>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3 19c.6-3.4 3-5.4 6-5.4s5.4 2 6 5.4" />
      <path d="M18 8v6M15 11h6" />
    </>
  ),
  correio: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3.5 6.5 8.5 6.5 8.5-6.5" />
    </>
  ),
  cacar: (
    <>
      <path d="M20 4v4L9.5 18.5l-4-4L16 4z" />
      <path d="M7 13l4 4" />
      <path d="M5.5 16.5 3 19l2 2 2.5-2.5" />
    </>
  ),
  viajar: (
    <>
      <path d="M9 3 3 6v15l6-3 6 3 6-3V3l-6 3z" />
      <path d="M9 3v15M15 6v15" />
    </>
  ),
  ordens: (
    <>
      <path d="M6 3h12v18l-6-4-6 4z" />
      <path d="M9 8h6M9 12h6" />
    </>
  ),
  lojas: (
    <>
      <path d="M4 10h16v10H4z" />
      <path d="M3 10l2-6h14l2 6" />
      <path d="M10 20v-5h4v5" />
    </>
  ),
  banco: (
    <>
      <path d="M3 9l9-5 9 5" />
      <path d="M5 10v8M9.5 10v8M14.5 10v8M19 10v8M3 20h18" />
    </>
  ),
  mercado: (
    <>
      <path d="M12 4v16M6 7h12" />
      <path d="M6 7l-3 6a3 3 0 0 0 6 0z" />
      <path d="M18 7l-3 6a3 3 0 0 0 6 0z" />
      <path d="M8 20h8" />
    </>
  ),
  oficios: (
    <>
      <path d="M3 10h10l3-3h4v4h-3l-2 2H7a4 4 0 0 1-4-3z" />
      <path d="M8 13v4M5 18h7" />
    </>
  ),
  guilda: (
    <>
      <path d="M5 3h14v11l-7 7-7-7z" />
      <path d="M9 8h6M12 8v7" />
    </>
  ),
  amigos: gente,
  /* §24: o manequim de treino (cabeça, poste, braços e a base) */
  treinar: (
    <>
      <circle cx="12" cy="5" r="2.4" />
      <path d="M12 7.4V20" />
      <path d="M5 10.5h14" />
      <path d="M8.5 13.5h7" />
      <path d="M8 21h8" />
    </>
  ),
  social: gente,
  mais: (
    <>
      <circle cx="5" cy="12" r="1.6" />
      <circle cx="12" cy="12" r="1.6" />
      <circle cx="19" cy="12" r="1.6" />
    </>
  ),
  cidade: (
    <>
      <path d="M3 21V10l4-3 4 3v11" />
      <path d="M11 21V6l5-3 5 3v15" />
      <path d="M3 21h18M14 9h4M14 13h4M6 13h2" />
    </>
  ),
  dano: <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />,
  /* Engrenagem de 8 dentes (o ícone antigo, raios em volta de um círculo, parecia um sol). */
  config: (
    <>
      <path d="M9.72 5.38 10.21 2.77 13.79 2.77 14.28 5.38 15.07 5.71 17.26 4.21 19.79 6.74 18.29 8.93 18.62 9.72 21.23 10.21 21.23 13.79 18.62 14.28 18.29 15.07 19.79 17.26 17.26 19.79 15.07 18.29 14.28 18.62 13.79 21.23 10.21 21.23 9.72 18.62 8.93 18.29 6.74 19.79 4.21 17.26 5.71 15.07 5.38 14.28 2.77 13.79 2.77 10.21 5.38 9.72 5.71 8.93 4.21 6.74 6.74 4.21 8.93 5.71Z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  perfil: (
    <>
      <circle cx="12" cy="7" r="4" />
      <path d="M5 21v-2a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v2" />
    </>
  ),
  som: (
    <>
      <path d="M4 9h4l5-4v14l-5-4H4z" />
      <path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12" />
    </>
  ),
  teclado: (
    <>
      <rect x="2.5" y="6" width="19" height="12" rx="2" />
      <path d="M6 10h1M9.5 10h1M13 10h1M16.5 10h1M7 14h10" />
    </>
  ),
  chat: (
    <>
      <path d="M4 5h16v11H9l-5 4z" />
      <path d="M8 9h8M8 12h5" />
    </>
  ),
  gm: (
    <>
      <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" />
      <path d="M9 12l2 2 4-4" />
    </>
  ),
  suporte: (
    <>
      <path d="M4 5h16v11H9l-5 4z" />
      <path d="M12 8v3M12 13.5h.01" />
    </>
  ),
  rankings: (
    <>
      <path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0z" />
      <path d="M7 6H4v1a3 3 0 0 0 3 3M17 6h3v1a3 3 0 0 1-3 3" />
    </>
  ),
  wiki: (
    <>
      <path d="M12 6.5C10 5 7 4.5 3.5 5v13c3.5-.5 6.5 0 8.5 1.5 2-1.5 5-2 8.5-1.5V5C17 4.5 14 5 12 6.5z" />
      <path d="M12 6.5v13" />
    </>
  ),
  /** O guia do jogo (as boas-vindas): uma placa de caminho. */
  guia: (
    <>
      <path d="M12 3v18M8 21h8" />
      <path d="M5 6h11l3 2.5-3 2.5H5zM19 13H9l-3 2.5L9 18h10z" />
    </>
  ),
  evento: (
    <>
      <path d="M5 4l3 3-3 3M19 4l-3 3 3 3" />
      <path d="M12 3l1.8 3.6 4 .6-2.9 2.8.7 4L12 12.1 8.4 14l.7-4L6.2 7.2l4-.6z" />
      <path d="M12 14v7M8 21h8" />
    </>
  )
};

export function IconeHud({ nome, className }: { nome: string; className?: string }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={className}>
      {PATHS[nome]}
    </svg>
  );
}

/** Tag como texto do React. O id do gradiente não pode ter dois-pontos. */
export function Brasao({ tag, grande }: { tag: string; grande?: boolean }) {
  const id = useId().replace(/:/g, '');
  const n = tag.length;
  return (
    <svg className={`p-brasao${grande ? ' p-brasao--grande' : ''}`} viewBox="0 0 64 72" aria-hidden="true">
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#2b3140" />
          <stop offset="1" stopColor="#12151a" />
        </linearGradient>
      </defs>
      <path d="M32 3 59 12v22c0 18-12 29-27 35C17 63 5 52 5 34V12z" fill={`url(#${id})`} stroke="#c9a227" strokeWidth="2.5" />
      <path d="M32 9 53 16v18c0 14-9 23-21 28C20 57 11 48 11 34V16z" fill="none" stroke="rgba(230,196,82,.35)" />
      <text
        x="32"
        y={n > 3 ? 42 : 44}
        textAnchor="middle"
        fontFamily="Cinzel, serif"
        fontWeight="700"
        fontSize={n > 3 ? 15 : n > 2 ? 18 : 22}
        fill="#e6c452"
        letterSpacing="1"
      >
        {tag}
      </text>
    </svg>
  );
}
